import { PricesService } from "./services/PricesService";

const apiUrl = process.env.REACT_APP_API_URL;
const apiV2Url = process.env.REACT_APP_REPORTING_V2_API_URL;

export const pricesService = new PricesService(apiV2Url);
